import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'wordSlice'
})
export class WordSlicePipe implements PipeTransform {
    transform(value: string, maxWordsLength: number = 10): string {
        const valueWords = value.split(' ');
        if (valueWords.length > maxWordsLength) {
            const result = valueWords.slice(0, maxWordsLength);
            return `${result.join(' ')} ...`;
        }
        return value;
    }
}
